<template>
  <template v-if="enhancedHtml">
    <div class="flex items-center justify-between">
      <label class="text-body text-black-2 font-semibold!">{{ label }}:</label>
      <RfButtonNew v-if="!disabled" type="ghost" size="xx-small" @click="modalOpen = true">
        <RfOpenInNewIcon class="h-4 w-4" /> Open editor
      </RfButtonNew>
    </div>
    <component
      :is="codeEditor.CodeEditor"
      v-model="model"
      v-bind="codeEditor.props"
      :languages="codeEditor.languages('html')"
      :readOnly="disabled"
      fontSize="13px"
    ></component>
    <RfCodeEditorModal v-model="modalOpen" v-model:code="model" language="html" :title="label" />
  </template>
  <v-textarea
    v-else
    v-model.trim="model"
    variant="outlined"
    hideDetails
    :density="density"
    :rows="rows"
    :label="label"
    :name="name"
    :disabled="disabled"
  ></v-textarea>
</template>

<script setup>
import { ref } from "vue";
import { useCodeEditor } from "@/utils/composables/useCodeEditor";
import RfCodeEditorModal from "@/components/modals/RfCodeEditorModal.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfOpenInNewIcon from "@/components/icons/RfOpenInNewIcon.vue";

const model = defineModel({ type: String, default: "" });

defineProps({
  label: { type: String, default: "" },
  name: { type: String, default: "" },
  rows: { type: [Number, String], default: 3 },
  density: { type: String, default: "default" },
  disabled: { type: Boolean, default: false },
  enhancedHtml: { type: Boolean, default: false },
});

const codeEditor = useCodeEditor();
const modalOpen = ref(false);
</script>
